module.exports = __webpack_public_path__ + "static/img/book6.a93e5c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book6.jpg
// module id = osM/
// module chunks = 1